import {
  SET_WILL_SWITCH_HB_BATTLE_ROOM_INFO,
  SET_CURR_HB_ROOM_INFO,
  ADD_HB_BATTLE_ROOM_MSG
} from "@/store/mutation_types";

const redPacketBattle = {
  state: {
    willSetHbBattleRoomInfo: {}, //将要设置为红包大战房间的房间信息
    currHbBattleRoomInfo: {}, // 当前红包房间的信息
    hbBattleRoomMsg: {} // 红包大战房间消息
  },
  getters: {
    willSetHbBattleRoomInfo: state => state.willSetHbBattleRoomInfo,
    currHbBattleRoomInfo: state => state.currHbBattleRoomInfo,
    hbBattleRoomMsg: state => state.hbBattleRoomMsg
  },
  mutations: {
    [SET_WILL_SWITCH_HB_BATTLE_ROOM_INFO]: (state, data) => {
      state.willSetHbBattleRoomInfo = data;
    },
    [SET_CURR_HB_ROOM_INFO]: (state, data) => {
      state.currHbBattleRoomInfo = data;
    },
    [ADD_HB_BATTLE_ROOM_MSG]: (state, data) => {
      state.hbBattleRoomMsg = data;
    }
  }
};

export default redPacketBattle;
